import React from 'react';


export const allStatuses = {
    Created: { //Создана
        color: 'grey',
        icon: 'text-file'
    },
    OnClientManager: { //У клиентского менеджера
        color: 'orange',
        icon: 'mailroom'
    },
    SentToMailRoom: { //Отправлена в mailroom
        color: 'orange',
        icon: 'mailroom'
    },
    CarrierRequestSent: { //Отправлена ТК
        color: 'blue',
        icon: 'truck'
    },
    CarrierRequestConfirmed: { //Подтверждена ТК
        color: 'blue',
        icon: 'done-blue'
    },
    CourierSearch: { //Поиск курьера
        color: 'orange',
        icon: 'search'
    },
    CourierFound: { //Курьер найден
        color: 'blue',
        icon: 'truck'
    },
    CarrierRequestRejected: { //Отклонена ТК
        color: 'red',
        icon: 'minus'
    },
    Shipped: { //Отгружено
        color: 'green',
        icon: 'box'
    },
    Lost: { //Потеряна
        color: 'border-red',
        icon: 'close-box'
    },
    Problems: { //Проблема
        color: 'violet',
        icon: 'problem'
    },
    Delivered: { //Доставлено
        color: 'green',
        icon: 'done'
    },
    CostConfirmPending: { //Согласование суммы
        color: 'yellow',
        icon: 'rub'
    },
    CostConfirmed: { //Стоимость согласована
        color: 'green-2',
        icon: 'coins'
    },
    CostNotConfirmed: { //Стоимость не согласована
        color: 'red-yellow',
        icon: 'coins-close'
    },
    Invoicing: { //Выставление счёта
        color: 'orange',
        icon: 'list'
    },
    InvoiceIssued: { //Счет выставлен
        color: 'grey-2',
        icon: 'list'
    },
    Completed: { //Завершено
        color: 'white-blue',
        icon: 'flag'
    },
    Cancelled: { //Отменено
        color: 'grey-3',
        icon: 'close'
    },
    Archived: { //В архиве
        color: 'white-blue',
        icon: 'archive'
    },
    InvoicePaid: { //Счет оплачен
        color: 'white-blue',
        icon: 'archive'
    }
}

const Status = ({name, code, circle}) => {
    const color = allStatuses[code] ? allStatuses[code].color : '';
    const icon = allStatuses[code] ? allStatuses[code].icon : '';
    return (
        <div className={`parcel-status ${circle ? 'circle ' : ''} ${!name ? 'noname ' : ''}parcel-status_${color} parcel-status_${icon}`}>
            {name}
        </div>
    );
};

export default Status;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/status.jsx